module.exports = __webpack_public_path__ + "img/img6.e4f0dd53.png";